import { Recommendation } from 'store/landing/slice';

export const gtmBlueshiftRecommendationEvent = (
  product: Recommendation, // clicked product
  pageType: 'product' | 'landing',
  currentProductId?: number,
  pageId?: string,
) => ({
  event: 'blueshiftRecommendation',
  pageType,
  currentProductId,
  pageId,
  clickedProductId: product.productId,
});

export default gtmBlueshiftRecommendationEvent;
